module.exports = __webpack_public_path__ + "static/media/jeff-musgrave-1200.70686c89.jpg";